import React from 'react';
import { Box, Typography, Grid } from '@mui/material';
import TeamIntegrationItem from './TeamIntegrationItem';
import { getIconComponent } from 'utils/icons/iconUtils';

const TeamRecommendedContainer = ({ 
    searchTerm = '', 
    subteamId = null,
    availableIntegrations = [],
    onIntegrationClick,
    isIntegrationConnected,
    getConnectionStatus
}) => {
    // Recommended integrations - Zoho is recommended
    const integrationNames = ['Zoho'];
    
    const recommendedIntegrations = integrationNames
        .map(name => {
            const backendIntegration = availableIntegrations.find(
                i => i.name === name || 
                     i.displayName === name ||
                     i.name === 'Zoho CRM' && name === 'Zoho'
            );
            
            if (backendIntegration) {
                return {
                    name: backendIntegration.displayName || backendIntegration.name,
                    backendName: backendIntegration.name, // Store backend name for click handler
                    displayName: backendIntegration.displayName || backendIntegration.name,
                    _id: backendIntegration._id,
                    isConnected: isIntegrationConnected ? isIntegrationConnected(name) : false,
                    connectionStatus: getConnectionStatus ? getConnectionStatus(name) : 'disconnected'
                };
            }
            
            return {
                name: name,
                backendName: name, // Fallback to name if no backend integration
                displayName: name,
                _id: null,
                isConnected: false,
                connectionStatus: 'disconnected'
            };
        })
        .filter(integration =>
            integration.name.toLowerCase().includes(searchTerm.toLowerCase())
        );

    if (recommendedIntegrations.length === 0 && searchTerm) {
        return null;
    }

    return (
        <Box>
            <Typography
                variant="h5"
                sx={{
                    fontWeight: 600,
                    mb: 3,
                    color: '#242020',
                    fontSize: '2rem'
                }}
            >
                Recommended
            </Typography>
            <Grid container spacing={2}>
                {recommendedIntegrations.map((integration) => (
                    <Grid item xs={12} sm={6} md={3} key={integration.name}>
                        <TeamIntegrationItem
                            text={integration.displayName === 'Zoho CRM' ? 'Zoho' : integration.displayName}
                            icon={getIconComponent(integration.backendName || integration.name)}
                            onClick={() => {
                                if (onIntegrationClick) {
                                    // Pass the backend name for proper matching
                                    onIntegrationClick(integration.backendName || integration.name);
                                }
                            }}
                            isConnected={integration.isConnected}
                            connectionStatus={integration.connectionStatus}
                        />
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

export default TeamRecommendedContainer;

